import {useFeatureIsOn} from "@growthbook/growthbook-react";

import type {AppFeatures} from "@khan/analytics-growthbook/app-features";
import {useCookies} from "@khan/data-cookies";

import {isLearnPrototypeEnabled} from "./cookie-storage.ts";

export const useLearnPrototypeEnabled = (): boolean | null => {
    const isFeatureFlagEnabled = useFeatureIsOn<AppFeatures>(
        "prototype-learn-enabled",
    );
    const cookies = useCookies();
    if (!cookies) {
        return isFeatureFlagEnabled;
    }

    return isFeatureFlagEnabled || isLearnPrototypeEnabled(cookies);
};
